import { render } from "./GaoN.vue?vue&type=template&id=4f36aa7f&scoped=true"
import script from "./GaoN.vue?vue&type=script&lang=js"
export * from "./GaoN.vue?vue&type=script&lang=js"

import "./GaoN.vue?vue&type=style&index=0&id=4f36aa7f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f36aa7f"]])

export default __exports__